import { jwtDecode } from 'jwt-decode';
import ReactMemory from '../ReactSession';

import AuthenticationService from '../service/AuthenticationService';

//Session customer
ReactMemory.setStoreType("memory");

const initAuthentication = (onAuthenticatedCallback) => {

  checkReactMemory();

  onAuthenticatedCallback();


};


const setAuthentication = (token) =>
  new Promise((resolve, reject) => {
    //console.log('setAuthentication', token);
    try {
      localStorage.removeItem("profileImage");


      localStorage.setItem("auth", token);

      let userInfo = parseToken(token);

      //console.log("userInfo", userInfo)

      ReactMemory.set("auth", userInfo);
      resolve(userInfo);
    } catch {
      reject("Unhandled Error")
    }


  });

const setProfileImage = (profileImage) => {
  localStorage.setItem("profileImage", profileImage);
}

const setHeaderImage = (headerImage) => {
  localStorage.setItem("headerImage", headerImage);
}
const getHeaderImage = () => {

  let headerImage = localStorage.getItem("headerImage");
  if (headerImage != null) {
    headerImage = localStorage.getItem("headerImage");
    return headerImage;
  }
}

const getProfileImage = (navigate) => {
  console.log("getUserType", getUserType());

  let profileImage = localStorage.getItem("profileImage");
  if (profileImage != null) {
    profileImage = localStorage.getItem("profileImage");
    return profileImage;

  }
}


const doLogout = async () => {
  console.log("dologoutcccccc");

  let _token = localStorage.getItem("auth");
  console.log("dologoutcccccc _token", _token);
  if (_token) {
    let decode = jwtDecode(_token);
    console.log("dologoutcccccc decode", decode);
    let username = decode.sub;
    console.log("dologoutcccccc username", username);
    await logout(username);
  }

};


const getToken = () => {
  let token = localStorage.getItem("auth");

  try {
    if (token != null && jwtDecode(token).exp < Date.now() / 1000) {
      console.log(jwtDecode(token).exp);
      localStorage.removeItem("auth");
      localStorage.removeItem("profileImage");

      ReactMemory.remove("auth");
      token = null;
    }
  } catch {
    ReactMemory.remove("auth");
    token = null;
  }
  return token;

}


const isLoggedIn = () => {

  if (getToken() != null) {
    parseToken(getToken());

    checkReactMemory();
    console.log('isLoggedIn', ReactMemory.get("auth"));
    return ReactMemory.get("auth");//TODO
  } else {
    return null;
  }
}


const getUserName = () => {
  let _token = parseToken(getToken());
  if (_token) {

    console.log('getUserName', getToken());
    console.log('getUserName', _token);
    return _token?.userName;
  } else {
    return null;
  }
}
const getFullName = () => {
  let _token = parseToken(getToken());
  if (_token) {

    console.log('getFullName', getToken());
    console.log('getFullName', _token);
    return _token?.firstName + " " + _token?.lastName;
  } else {
    return null;
  }
}
const hasBluetick = () => {
  let _token = parseToken(getToken());
  if (_token) {
    return _token?.hasBluetick;
  } else {
    return null;
  }
}
const getAccountId = () => {
  let _token = parseToken(getToken());
  return _token?.accountId;
}
const getUserId = () => {
  let _token = parseToken(getToken());
  return _token?.userId;
}
const getUserType = () => {
  let _token = parseToken(getToken());
  return _token?.userType;
}

const getUserMail = () => {
  let _token = parseToken(getToken());
  return _token?.sub;
}


const hasRole = (roles) => true;//TODO

const checkReactMemory = () => {
  //console.log("checkReactMemory");
  if (!ReactMemory.get("auth")) {

    if (getToken() != null) {

      let token = getToken();
      let userInfo = parseToken(token);

      //console.log("userInfo", userInfo);

      ReactMemory.set("auth", userInfo);

    }
  }
}

const parseToken = (token) => {

  try {
    if (token) {
      //console.log("parseToken orj", token);
      let parseToken = jwtDecode(token);
      return parseToken;
    } else {
      return null;
    }

  } catch (error) {
    console.log("error******", error);
    doLogout();
  }

}

const checkPermission = (pageViewPermission) => {
  checkReactMemory();

  //console.log(ReactMemory.get("auth")?.auth)
  if (ReactMemory.get("auth")?.auth != null) {
    let permissions = ReactMemory.get("auth")?.auth;
    if (permissions !== null) {
      if (pageViewPermission) {


        const filteredPermissions = permissions.filter((permission) => {
          //console.log("filteredPermissions", permission.authority.trim(), pageViewPermission);
          if (permission.authority === pageViewPermission) {
            return true;
          } else {
            return false;
          }
        });

        if (filteredPermissions && filteredPermissions.length) {
          return true;
        }
      } else {
        return true;
      }
    }
  }
  return false;
}

const checkPermissionOr = (permissions) => {
  let _status = false;
  permissions.forEach(permission => {
    let _check = checkPermission(permission);
    if (_check) {
      _status = _check;
    }
  });
  return _status;
}


const logout = async (username) => {
  console.log("logout", username);
  try {
    if (username) {
      await AuthenticationService.signout(username).then(
        (response) => {
          console.log("AuthenticationService.signout", response);
          if (response?.status >= 200 && response?.status < 300) {
            console.log("signout", response);
            localStorage.removeItem("auth");
            localStorage.removeItem("profileImage");

            ReactMemory.remove("auth");
          }
        });
    }


  } catch (err) {
    console.error(err);
  }

}


const saveMemory = (param, data) => {
  localStorage.setItem(param, data);
}
const inquireMemory = (param) => {

  return localStorage.getItem(param);
}
const deleteMemory = (param) => {

  return localStorage.removeItem(param);
}

const AuthService = {
  initAuthentication,
  doLogout,
  isLoggedIn,
  getToken,
  getUserName,
  hasRole,
  checkPermission,
  setAuthentication,
  getAccountId,
  checkPermissionOr,
  getUserId,
  getUserType,
  getProfileImage,
  setProfileImage,
  saveMemory,
  inquireMemory,
  deleteMemory,
  getFullName,
  hasBluetick,
  setHeaderImage,
  getHeaderImage,
  getUserMail,
};

export default AuthService;